import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { IconSize } from './BaseIcon';

const LIME = '#D4E157';
const CENTER = 12;
const SPREAD = 4.2;
const DOT_R = 2.2;
const MERGED_R = 5;
const TRANSITION =
  'cx 0.45s cubic-bezier(0.22,1,0.36,1), cy 0.45s cubic-bezier(0.22,1,0.36,1), r 0.45s cubic-bezier(0.22,1,0.36,1), fill 0.45s cubic-bezier(0.22,1,0.36,1), opacity 0.45s cubic-bezier(0.22,1,0.36,1)';

const STYLES = `
  .studio-logo-dot {
    transition: ${TRANSITION};
  }
  .studio-logo-dot.tl { cx: ${CENTER - SPREAD}; cy: ${CENTER - SPREAD}; r: ${DOT_R}; fill: ${LIME}; opacity: 0.55; }
  .studio-logo-dot.tr { cx: ${CENTER + SPREAD}; cy: ${CENTER - SPREAD}; r: ${DOT_R}; fill: #fff; opacity: 0.4; }
  .studio-logo-dot.bl { cx: ${CENTER - SPREAD}; cy: ${CENTER + SPREAD}; r: ${DOT_R}; fill: #fff; opacity: 0.4; }
  .studio-logo-dot.br { cx: ${CENTER + SPREAD}; cy: ${CENTER + SPREAD}; r: ${DOT_R}; fill: ${LIME}; opacity: 0.55; }

  [data-studio-logo-hovered] .studio-logo-dot,
  [data-sidebar="menu-button"]:hover .studio-logo-dot,
  button:hover > .studio-logo-wrap .studio-logo-dot {
    cx: ${CENTER}; cy: ${CENTER}; r: ${MERGED_R}; fill: ${LIME}; opacity: 0.45;
  }
`;

/**
 * Studio Assistant logo — four dots in a diagonal quad.
 * On hover, all four converge into a single lime circle.
 *
 * Hover triggers:
 * - `hovered` prop (for controlled hover via JS)
 * - Parent `button:hover` (for the ContinuationWidget pill)
 * - Parent `[data-sidebar-menu-button]:hover` (for the sidebar)
 */
export const StudioAssistantLogo: FC<IconProps & { hovered?: boolean }> = ({
  size = 'md',
  hovered,
  className,
}) => {
  const px = IconSize[size];

  return (
    <span
      className={className}
      data-studio-logo-hovered={hovered || undefined}
      style={{ display: 'contents' }}
    >
      <style>{STYLES}</style>
      <span className="studio-logo-wrap" style={{ display: 'contents' }}>
        <svg
          fill="none"
          height={px}
          style={{ overflow: 'visible', flexShrink: 0 }}
          viewBox="0 0 24 24"
          width={px}
        >
          <circle className="studio-logo-dot tl" />
          <circle className="studio-logo-dot tr" />
          <circle className="studio-logo-dot bl" />
          <circle className="studio-logo-dot br" />
        </svg>
      </span>
    </span>
  );
};
